import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpDelete, httpPost} from '../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../constants/MicroServiceConstants';

const initialData = {
  parentClientData: [],
  parentClientSatus: null,
  addParentClientStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'parentClientInformation',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },

    getParentClient: (state, action) => {
      state.parentClientData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postParentClient: (state, action) => {
      state.parentClientSatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    deleteParentClient: (state, action) => {
      state.parentClientSatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetClientContact: (state) => {
      state.parentClientSatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.parentClientData = [];
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  getParentClient,
  resetMsg,
  fetchStart,
  fetchError,
  deleteParentClient,
  resetClientContact,
  postParentClient,
  resetData,
} = slice.actions;

export const fetchParentClientInfo = (parentClientId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/all/parentclientcontact/${parentClientId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getParentClient(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const deleteParentClientContact = (parentClientId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpDelete(`${CLIENT_MAINTENANCE}/delete/parentclientcontact/${parentClientId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(deleteParentClient(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postParentCintactInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/parentclientcontact`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postParentClient(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetClientContact());
  };
};
export const resetClientData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
